import QuotesView from "../views/QuotesView";
import QuoteView from "../views/QuoteView";
import MyQuotesView from "../views/MyQuotesView";
import { UserRole } from "../lib/models/enums";
import { elevatedUsers, internalUsers } from "../lib/UserPermissions";
import BrokerQuotesView from "../views/BrokerQuotesView";
import BrokerByIdQuotesView from "../views/QuotesByBrokerView";
import UserByIdQuotesView from "../views/QuotesByUserView";
import BorrowerByIdQuotesView from "../views/QuotesByBorrowerView";
import { LogoutView } from "../views/LogoutView";

export type Route = {
  path: string;
  name: string;
  Component: any;
  secured: boolean;
  exact: boolean;
  roles?: UserRole[];
  fallback?: string;
};

export const routes: Route[] = [
  {
    path: "/quotes",
    name: "All Quotes",
    Component: QuotesView,
    secured: true,
    exact: true,
    roles: elevatedUsers,
    fallback: "/quotes/my-quotes",
  },
  {
    path: "/quotes/my-quotes",
    name: "My Quotes",
    Component: MyQuotesView,
    secured: true,
    exact: true,
  },
  {
    path: "/quotes/users/:id",
    name: "User Quotes",
    Component: UserByIdQuotesView,
    secured: true,
    exact: true,
    roles: elevatedUsers,
  },
  {
    path: "/quotes/broker-quotes",
    name: "Broker Quotes",
    Component: BrokerQuotesView,
    secured: true,
    exact: true,
  },
  {
    path: "/quotes/brokers/:id",
    name: "Single Broker Quote",
    Component: BrokerByIdQuotesView,
    roles: internalUsers,
    secured: true,
    exact: true,
  },
  {
    path: "/quotes/borrowers/:id",
    name: "Single Borrower Quote",
    Component: BorrowerByIdQuotesView,
    roles: internalUsers,
    secured: true,
    exact: true,
  },
  {
    path: "/quotes/:id/edit",
    name: "Edit Quote",
    Component: QuoteView,
    secured: true,
    exact: false,
  },
  {
    path: "/quotes/new",
    name: "New Quote",
    Component: QuoteView,
    secured: true,
    exact: false,
  },
  {
    path: "/logout",
    name: "Log Out",
    Component: LogoutView,
    secured: true,
    exact: false,
  },
];
